import axios from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IGetCreditUsagePayload,
  IGetProjectCreationPayload,
} from './types'

export function getCreditUsage(payload: IGetCreditUsagePayload) {
  return axios.get('/api/v1/statistics/credit_usage', { params: convertToSnakeCase(payload) })
}

export function getProjectCreation(payload: IGetProjectCreationPayload) {
  return axios.get('/api/v1/statistics/project_creation', { params: convertToSnakeCase(payload) })
}
